<template>
  <div class="take-over-message">
    <div class="take-over-message-content">
      {{ message.data.text }}
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      messageShow: ''
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {},
  methods: {}
}
</script>
<style scoped>
.take-over-message {
  margin: auto;
  padding: 24px 12px 24px;
  
}

.take-over-message-content {
  background: gray;
  padding-left: 12px;
  padding-right: 12px;
  min-width: 142px;
  height: 22px;
  margin: auto;
  text-align: center;
  align-self: baseline;
  border-radius: 11px;
  height: auto;
  font-size: 14px;
  line-height: 22px;
  animation: fadeInAnimation ease 2s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.7;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/beautiful-chat/TakeOverMessage.vue